export default __webpack_public_path__ + "i18n/translations/translation-nl.a41dcc9e.json";